<div class="video-overlay" *ngIf="PDF_Url">
    <button type="button" mat-icon-button (click)="close.emit()">
        <img src="./assets/images/icons/ic_close.svg" alt="">
    </button>
    <iframe [src]="safeLink(PDF_Url) " frameborder="5"></iframe>
</div>